














import { TeamReportData } from "@/store/state";
import { Component, Prop, Vue } from "vue-property-decorator";
import IndividualBreakdownChart from "@/components/team/IndividualBreakdownBarChart.vue";
import { ActionTypes } from "@/store/actions";

@Component({
  components: { IndividualBreakdownChart }
})
export default class IndividualBreakdown extends Vue {
  @Prop()
  teamReportDataArray!: TeamReportData[];

  get teamName() {
    return this.$store.getters.returnIndividualTeamName;
  }

  get showBreakdown() {
    return this.$store.getters.returnShowBreakdown;
  }

  hideBreakdown() {
    this.$store.commit(ActionTypes.HideIndividualBreakdown);
  }
}
